export default {
  promoInfo: 'Promo Info',
  shop: 'Query Per Shop',
  brand: 'Query Per Brand',
  promoHistory: 'Promo History',
};
